module.exports = __webpack_public_path__ + "media/images/newsletter/newsletter-home-ec-c73bcdf00276a78813a56010f4aa54dc.png";